import { last, first } from "lodash";
import { useParameter, useDictionaryItem, yearToCropYearShort } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";

export function useSlideSubtitle() {
  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarStartName] = useDictionaryItem(dictionaryService, "slides-calendar", first(parameterValues));
  const [, calendarEndName] = useDictionaryItem(dictionaryService, "slides-calendar", last(parameterValues));
  const yearStart = calendarStartName ? Number(calendarStartName) : new Date().getFullYear() - 1;
  const yearEnd = calendarEndName ? Number(calendarEndName) : new Date().getFullYear() - 1;
  const subtitle = `${yearStart} - ${yearEnd}`;

  return subtitle;
}
